import React ,{ Component }from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor,FiDollarSign, FiPhone, FiSmartphone, FiEye } from "react-icons/fi";

const ServiceList = [

    {
        icon: <FiMonitor />,
        title: 'Front-End Development',
        description: 'Implementing user interfaces into code using various frameworks like React.Js, Vue js, CodeIgniter and Laravel'
    },
    {
        icon: <FiLayers />,
        title: 'Back-End Development',
        description: 'I also make web services(APIs) according to the needs from the front-end using Laravel, Go (Fiber) and CodeIgniter'
    },
    { 
        icon: <FiSmartphone />,
        title: 'Mobile Development',
        description: 'Here where I always been trusted to work at, the lack of mobile programmers here and my adaptive nature in learning, the UI designed, is the reason that Im always here'
    },
    {
        icon: <FiEye />,
        title: 'UI/UX',
        description: 'Intuitive by nature, guides me how to design. I always pay attention the layout, color combination, the bigger picture of how may programs would look and feel'
    },
    {
        icon: <FiUsers />,
        title: 'Digital Marketing',
        description: 'I let others know the apps I published using Google Ads & Social Media. More traffics or users, means more money!'
    },
    { 
        icon: <FiDollarSign />,
        title: 'Digital Monetization',
        description: 'Publishing the apps I develop is definitely aimmed to be profitable, I use platforms like AdMob, Meta Audience network, AppLovin etc'
    },

   
]


class ServiceThree extends Component{
    render(){
        const {column } = this.props;
        const ServiceContent = ServiceList.slice(0 , this.props.item);
        
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
   
                                <div className="service service__style--2">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                          
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
